import React from "react"
import { InputNumber, Typography } from "antd"
import { PrimeButton } from "components-design-system"
import useAppState from "context/hooks/useAppState"

// constants
import { THRESHOLD_KEY } from "constants/grids"

// styles
import "./ComplianceThreshold.scss"

const { Title } = Typography

const ComplianceThreshold = (props) => {
  const { openToastNotification } = useAppState()
  const [threshold, setThreshold] = React.useState(30)

  React.useEffect(() => {
    let savedThreshold = Number(localStorage.getItem(THRESHOLD_KEY))
    if (!isNaN(savedThreshold)) setThreshold(savedThreshold)
  }, [])

  const onApply = () => {
    localStorage.setItem(THRESHOLD_KEY, threshold)
    props.api.sideBarService.sideBarComp.close()
    props.api.refreshServerSide()
    openToastNotification("success", "Success", "Successfully applied compliance threshold")
  }

  return (
    <div className="compliance-threshold-panel-container">
      <Title
        level={5}
        className="title"
      >
        Compliance Threshold
      </Title>
      <InputNumber
        id="compliance-threshold-input"
        min={0}
        value={threshold}
        onChange={setThreshold}
      />
      <PrimeButton
        type="primary"
        onClick={onApply}
        className="apply-btn"
      >
        Apply
      </PrimeButton>
    </div>
  )
}

export default ComplianceThreshold
